import { BaseResponse } from "@/types/dto/base-response";
import { CategoryDto } from "@/types/dto/category-dto";
import { AxiosInstance } from "axios";
import { baseApi } from "./base-api";

enum CategoryServiceEndpoint {
  GetAllV2 = "/category/v2",
}

class CategoryService {
  private static instance: CategoryService;
  private _api: AxiosInstance;

  private constructor(api: AxiosInstance) {
    this._api = api;
  }

  static getInstance(apiClient = baseApi): CategoryService {
    if (!CategoryService.instance) {
      CategoryService.instance = new CategoryService(apiClient);
    }
    return CategoryService.instance;
  }

  async getAll(
    includePackage: boolean
  ): Promise<BaseResponse<CategoryDto[], void>> {
    try {
      const response = await this._api.get<BaseResponse<CategoryDto[], void>>(
        CategoryServiceEndpoint.GetAllV2,
        {
          params: {
            includePackage,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error getAll:", error);
      throw error;
    }
  }
}

export const categoryService = CategoryService.getInstance(baseApi);
